// extracted by mini-css-extract-plugin
module.exports = {"blog":"Blog_blog__1Fw4Y"};